export default {
  myBalance: 'Mi saldo',
  topUp: 'Recargar',
  pay: 'Pagar',
  repayment: 'Pago',
  balance: 'Saldo',
  usableBalance: 'Crédito disponible',
  inputBalance: 'Por favor, ingrese el monto',
  payBalance: 'Monto de recarga',
  pecenter: 'Centro personal',
  lang: 'Idioma',
  cart: 'Carrito de compras',
  recipientName: 'Destinatario',
  goRecharge: 'Recargar ahora',
  phone: 'Teléfono',
  region: 'Región',
  address: 'Dirección detallada',
  country: 'País o región',
  province: 'Provincia',
  city: 'Ciudad',
  postcode: 'Código postal',
  action: 'Operación',
  mobileSettings: 'Configuración móvil',
  name: 'Nombre',
  debt: 'DEUDA',
  add: 'Agregar dirección de facturación de tarjeta de crédito',
  addSuccess: 'Agregado con éxito',
  editSuccess: 'Editado con éxito',
  editBtn: 'Editar',
  edit: 'Editar dirección de facturación de tarjeta de crédito',
  del: 'Eliminar',
  setDefault: 'Establecer como predeterminado',
  defaultAddress: 'Dirección predeterminada',
  setDefaultAddress: 'Establecer como dirección de envío predeterminada',
  setSuccess: 'Establecido con éxito',
  myAddress: 'Mi dirección',
  addAddress: 'Agregar nueva dirección',
  tradeTime: 'Hora de la transacción',
  type: 'Tipo',
  incomeOrExpend: 'Ingreso/Gasto',
  accountBalance: 'Saldo de la cuenta',
  tradeNo: 'ID de transacción',
  remark: 'Observación',
  tag: 'Etiqueta de dirección',
  addBillAddress: 'Agregar dirección de facturación de tarjeta de crédito',
  deleteBillAddress: 'Eliminar dirección de facturación',
  editBillAddress: 'Editar dirección de facturación',
  mergePay: 'Pagar juntos',
  username: 'Nombre de usuario',
  gender: 'Género',
  birthday: 'Cumpleaños',
  avatar: 'Avatar',
  email: 'Correo electrónico',
  site: 'Sitio web',
  myOrder: 'Pedido',
  sideBar: {
    myAccount: 'Mi cuenta',
    addressManage: 'Gestión de direcciones',
    myAsset: 'Billetera',
    billAddress: 'Dirección de facturación',
  },
  addDoorNoTips: 'Por favor, añada el número de casa a su dirección de entrega.',
  holder: {
    receiver: 'Destinatario',
    firstName: 'Nombre',
    name: 'Apellido',
    region: 'Por favor, seleccione Provincia/ciudad/Distrito/calle',
    address:
      'Por favor, ingrese información de dirección detallada, como calle, número de casa, comunidad, número de edificio, unidad, etc.',
    phone: 'Número de teléfono, el número de teléfono móvil debe llenar un campo',
    input: 'por favor ingrese',
    select: 'por favor seleccione',
    tagHolder: 'Máx. 120 letras (opcional)',
    postCodeNoMatch: 'El código postal no coincide con la región',
    doorNo: 'Número de casa',
  },
  forget: {
    accountSafe: 'Seguridad de la cuenta',
    setPwd: 'Cambiar contraseña',
    inputBindEmail: 'Por favor, ingrese su correo electrónico vinculado',
    inputVerifyCode: 'Por favor, ingrese el código de verificación',
    inputPwd: 'Por favor, ingrese la nueva contraseña',
  },
  accountInfo: {
    name: 'Cuenta',
    selfInfo: 'Información personal',
    cardBillAddress: 'Dirección de facturación de tarjeta de crédito',
    shipAddress: 'Dirección de envío',
    editUser: 'Editar información de usuario',
    inputCountry: 'Por favor, ingrese su país',
    editEmail: 'Editar correo electrónico',
    editEmailHint:
      '(Recomendado solo cuando el correo electrónico está configurado incorrectamente o tiene problemas)',
    editEmailHint1:
      'Para la seguridad de su cuenta, primero debe pasar la verificación de seguridad con "Código de verificación de correo electrónico + contraseña de inicio de sesión"',
    editEmailHint2:
      'Para la seguridad de su cuenta, primero debe pasar la verificación de seguridad con "Código de verificación de correo electrónico"',
    currentEmail: 'Correo electrónico actual',
    clickVerify: 'Enviar',
    reGet: 'Reenviar',
    nextStep: 'Siguiente paso',
    notReGetCode: 'Reenviar después de',
    logoutAccount: 'Cerrar sesión de la cuenta',
    emailNotEmpty: 'El correo electrónico no puede estar vacío',
    logoutReason: 'Por favor, seleccione la razón para cerrar sesión',
    latelyLogin: 'Inicio de sesión reciente',
    moreRecord: 'Más registros',
    visitRecord: 'Registros de visita',
    visitTime: 'Hora de visita',
    ipAndDevice: 'Dirección IP y tipo de dispositivo',
    editLoginPwdHint:
      'Una contraseña de alta seguridad puede hacer que su cuenta sea más segura. Se recomienda que cambie su contraseña regularmente y establezca una contraseña que incluya números y letras y tenga más de 6 dígitos.',
    editPayPwdHint:
      'La contraseña requerida al pagar con el saldo de acbuy. Establezca la contraseña de pago para garantizar la seguridad del pago.',
    editVerifyEmailHint:
      'Para proteger la seguridad de su cuenta, por favor verifique su correo electrónico.',
    payPwd: 'Contraseña de pago',
    editPayPwd: 'Cambiar contraseña de pago',
    setPayPwd: 'Establecer contraseña de pago',
    deleteAccount: 'Eliminar cuenta',
  },
  logoutReasonEnum: {
    0: 'Problemas de seguridad/privacidad',
    1: 'Servicio al cliente deficiente',
    2: 'Costos demasiado altos',
    3: 'Proceso de compra complicado',
    4: 'Otras razones',
  },
  tradeTypeEnum: {
    0: 'Ingreso',
    1: 'Gasto',
  },
  asset: {
    currentBalance: 'Saldo actual',
    canWithdrawBalance: 'Monto disponible para retiro',
    withdraw: 'Retirar',
    serialNo: 'Número de serie',
    amount: 'Monto',
    lossAmount: 'Monto gastado',
    withdrawAmount: 'Monto de retiro',
    inputWithdrawAmount: 'Por favor, ingrese el monto de retiro',
    withdrawSuccess: 'SRetiro enviado, el procesamiento puede demorar hasta 72 horas.',
    transactionDate: 'Fecha de transacción',
    withdrawMethod: 'Método de retiro',
    availableAmount: 'Monto disponible',
    transactionNo: 'Número de transacción',
    withdrawMsg:
      'Nota: El retiro del saldo se devolverá a través del canal original. El saldo se devolverá a la cuenta de pago de la transacción de retiro de acuerdo con el registro de gastos históricos.',
    transactionRecordsText: 'Registros de transacciones de monto disponible',
    withdrawRecordText: 'Registros de retiro',
  },
  package: {
    packageInfo: 'Información del paquete',
    weightHaveUnit: 'Peso (g)',
    sizeHaveUnit: 'Tamaño (cm)',
    freight: 'Flete',
    fee: 'Tarifa',
    transportMode: 'Modo de entrega',
    allPackage: 'Todos los paquetes',
    myPackage: 'Paquete',
  },
  packageStatusEnum: {
    0: 'Fondos pendientes',
    1: 'Sin pagar',
    2: 'En tránsito',
    3: 'Completado',
    4: 'Cancelado',
  },
  storage: {
    name: 'Almacén',
    warehouseTime: 'Hora de entrada al almacén',
    submitTransport: 'Enviar para entrega',
    lineCanUse: 'Piezas disponibles',
    commonImg: 'Fotos de control de calidad',
    customPhoto: 'Fotos personalizadas',
    extendCare: 'Extender el período de almacenamiento',
    extendHint:
      'El período de almacenamiento de sus productos en el almacén se extenderá por (30 * N) días. La nueva fecha de vencimiento es:',
    packMode: 'Método de empaquetado',
    retainPack: 'Empaque reservado',
    normalPack: 'Empaque predeterminado',
    normalPackHint: 'Los artículos se empaquetarán con su empaque original.',
    foldPack: 'Empaque plegado',
    foldPackHint:
      'Para las cajas de cartón no fijadas con pegamento, el almacén las desarmará, las doblará y las colocará en el paquete del usuario, lo que puede reducir el volumen del paquete en cierta medida. Pero también hay casos en los que el volumen del paquete aumenta (cuando hay menos mercancías, la longitud y el ancho del pliegue de la caja de cartón pueden aumentar).',
    discardPack: 'Descartar empaque',
    discardPackHint:
      'Después de descartar el empaque, el vendedor puede no aceptar ningún servicio posterior y no se puede encontrar o agregar de nuevo el empaque.',
    photoTemplate: 'Plantilla de foto',
  },
  operate: 'Operación',
  editAddress: 'Editar dirección',
  underPaid: 'Sin pagar',
  goTopay: 'Ir a pagar',
  viewRecord: 'Ver registro',
  faq: 'Preguntas frecuentes',
  question1: 'P: ¿Se bloqueará mi cuenta si solicito un retiro?',
  response1:
    'R: Después de solicitar el retiro, la cuenta bloqueará el monto de la solicitud para garantizar que el monto del reembolso sea el mismo que el monto que solicitó.',
  question2:
    'P: ¿"Completado" en los registros de retiro significa que el retiro del fondo fue exitoso?',
  response2:
    'R: "Completado" significa que acbuy ha programado un reembolso, pero el tiempo que tarda en llegar a su cuenta original depende del tiempo de procesamiento de la plataforma de terceros.',
  question3: 'P: ¿El retiro se basa en la tasa de cambio en tiempo real?',
  response3:
    'R: No, la tasa de cambio para el retiro se basa en el momento en que se recargó el fondo.',
  question4:
    'P: ¿Cómo hacer un retiro cuando el saldo de la cuenta es diferente del monto de retiro?',
  response4:
    'R: Cuando el saldo de la cuenta es mayor que el monto de retiro, puede solicitar en lotes hasta que el saldo de la cuenta sea 0. Cuando el saldo de la cuenta es menor que el monto de retiro, puede solicitar un retiro total en una sola ocasión.',
  stillRecharge: 'No es suficiente para pagar el pedido, aún se necesita recargar',
  amountDue: 'Monto a pagar',
  handingFee: 'Gastos de gestión',
  coupon: 'Cupón',
  couponPlaceholder: 'Canjear cupones con códigos de cupón',
  off: 'DESCUENTO',
  minFee: 'Tarifa mínima',
  freightText: 'Flete',
  limitTo: 'Limitado a',
  shippingUsage: 'Uso de envío',
  availableWarehouse: 'Almacén disponible',
  shippingFeeText: 'Tarifa de envío (excluye la tarifa de despacho aduanero)',
  internationalParcel: 'Paquete internacional',
  to: 'a',
  availableCoupons: 'Cupones disponibles',
  usedCoupons: 'Cupones utilizados',
  expiredCoupons: 'Cupones expirados',
  exchangeSuccess: '¡Canje exitoso!',
  myAffiliate: {
    name: 'Mi afiliado',
  },
  affiliateShare: 'Compartir',
  copyText: 'Copiar',
  affiliateShareMsg:
    'Los pagos de envío realizados a través de enlaces compartidos generarán ganancias de comisión para usted.',
  businessType: 'Tipo de negocio',
  payWay: 'Tipo de transacción',
  bzOrderNo: 'Nº AC',
  amountDueTooltip:
    'Debido a los cálculos de conversión de la tasa de cambio de moneda, puede haber una diferencia de aproximadamente 0.01 o 0.02',
  balanceStatement: 'Estado de cuenta',
  billFlow: 'Factura',
  affiliateFavorite: 'favorito',
  favourite: 'Favorito',
  canUseCountry: 'Países disponibles',
  commonNo: 'Número',
  question5: 'P: ¿Cuánto tiempo tarda en llegar el retiro a mi tarjeta?',
  response5:
    'R: El tiempo de procesamiento de los retiros puede variar según el método de pago y el banco, y suele ser de 2 a 25 días. Normalmente, los retiros se devolverán a su método de pago original o de recarga en un plazo de 48 horas. Si no recibe el retiro en 48 horas, puede contactar con atención al cliente para verificar el estado de su retiro.',
}
